import { Component, ErrorInfo } from 'react'

import { ErrorBoundaryProps } from '../../types/ComponentProps'

type State = {
  hasError: boolean
}

class ErrorBoundary extends Component<ErrorBoundaryProps, State> {
  state: State = {
    hasError: false
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    this.setState({
      hasError: true
    })

    this.props.onError(error, info)
  }

  render() {
    const { errorComponent, children } = this.props
    const { hasError } = this.state

    return hasError ? errorComponent : children
  }
}

export default ErrorBoundary
